import {
  responsiveFontSize,
  responsiveHeight,
  responsiveWidth,
} from 'react-native-responsive-dimensions';
import {isWeb} from '../constants';

export function customResponsiveHeight(dim: number) {
  const total = responsiveHeight(100);
  const base = 600;
  if (total < base) {
    return responsiveHeight(dim);
  } else {
    return (
      ((responsiveHeight(100) - base) * 0.6 * dim) / 100 + (dim / 100) * base
    );
  }
}

export function customResponsiveWidth(dim: number) {
  return responsiveWidth(dim);
}

export function customResponsiveFont(dim: number) {
  const total = responsiveFontSize(100);
  const base = 735;
  if (total < base) {
    return responsiveFontSize(dim);
  } else {
    switch (isWeb) {
      case true:
        return (
          ((responsiveFontSize(100) - base) * 0.15 * dim) / 100 +
          (dim / 100) * base
        );
      default:
        return (
          ((responsiveFontSize(100) - base) * 0.33 * dim) / 100 +
          (dim / 100) * base
        );
    }
  }
}

export function pixelResponsiveHeight(px: number) {
  return (px / 812) * customResponsiveHeight(100);
}

export function pixelResponsiveWidth(px: number) {
  return (px / 375) * customResponsiveWidth(100);
}

export function pixelResponsiveFont(px: number) {
  // return px * 0.14 * customResponsiveFont(1);
  return px;
}

export function pixelSquareResponsiveSize(px: number) {
  // let totalHeight = customResponsiveHeight(100);
  // let totalWidth = customResponsiveWidth(100);
  // let aspectRatio = totalWidth / totalHeight;
  // let average =
  //   (pixelResponsiveHeight(px) * aspectRatio +
  //     pixelResponsiveWidth(px) / aspectRatio) /
  //   2;
  // return average;
  return pixelResponsiveFont(px);
}
